"use strict";

class UrlHistoryItem {
    url = "";
    tag = "";

    constructor(url, tag)
    {
        this.url = url;
        this.tag = tag;
    }
}

export class UrlHistoryManager {
    history = [];
    options = {
        history_max_length: 30,
        storage_key: "url-history",
        selector_store_url: 'head[data-uri]',
        selector_redirect_last_url: '#redirect-last-url',
        filter_tags: ['sign', 'invite', 'lostPassword', 'managementInProgress'],
    };

    constructor(userOptions = {}) {
        const sessionHistory = sessionStorage.getItem(this.options.storage_key);
        this.history = sessionHistory ? JSON.parse(sessionHistory): [];
        for (const prop in userOptions) {
            if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
                this.options[prop] = userOptions[prop];
            }
        }

        this.initSelectors(document);
    }

    initSelectors(rootElement) {
        this.tryToStoreUrlAndRedirect(rootElement);
        this.tryToRedirectLastUrl(rootElement);
    }

    add(url, tag) {
        if (!tag || this.options.filter_tags.includes(tag) ) {
            return;
        }
        this.history.push(new UrlHistoryItem(url, tag));
        if (this.history.length > this.options.history_max_length) {
            this.history.shift();
        }
        sessionStorage.setItem(this.options.storage_key, JSON.stringify(this.history));
    }

    tryToStoreUrlAndRedirect(rootElement) {
        const url_element = rootElement.querySelector(this.options.selector_store_url);
        if (url_element) {
            const url = url_element.getAttribute("data-uri");
            const tag = url_element.hasAttribute("data-tag") ? url_element.getAttribute("data-tag") : "";
            this.add(url, tag);
            if (url_element.hasAttribute("data-redirect")) {
                window.location.replace(url_element.getAttribute("data-redirect"));
            }
        }
    }

    tryToRedirectLastUrl(rootElement) {
        const url_element = rootElement.querySelector(this.options.selector_redirect_last_url);
        if (url_element) {
            if (this.history.length > 0) {
                window.location.replace(this.history[this.history.length - 1].url);
            }else{
                window.location.replace('/');
            }
        }
    }
}